import { render, staticRenderFns } from "./SubTitleForm.vue?vue&type=template&id=67af3e73&"
import script from "./SubTitleForm.vue?vue&type=script&lang=js&"
export * from "./SubTitleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports